jQuery(() => {
	const $b = $('body'),
		$form = $b.find( '.report-search form' );

	// Form change
	if( $form.length ){
		let ajaxContainer = $b.find( '.report-list.ajax-container' );
		let $loader = $b.find( '.report-list .report-loading' );

		$b.on('change', $form, function (e) {
			let filterParams = $form.serializeArray();
			let fixedFilterParams = {};

			// Generate GET params for URL
			filterParams.forEach(param => {
				const name = param.name.replace('[', '').replace(']', '');
				const value = param.value === 'on' ? 1 : param.value;
				if( fixedFilterParams[name] !== undefined ) {
					fixedFilterParams[name].push(value);
				} else {
					fixedFilterParams[name] = [value];
				}
			});

			let query = new URLSearchParams(fixedFilterParams);
			let queryString = '?' + decodeURIComponent(query.toString());

			if( $form.parent().hasClass( 'force-redirect' ) ){
				let url_origin = $form.parents( 'section.block' ).find( 'a.btn.btn-rounded' ).attr( 'href' );

				// Concat the new URL
				window.location.href = url_origin + queryString;
			} else {
				let url_origin = window.location.origin;
				let url_pathname = window.location.pathname;
				let regexp = /page\/(.*)\//;

				// Remove pagination from URL
				let new_url_pathname = url_pathname.replace( regexp, '' );

				// Concat the new URL
				let new_url = url_origin + new_url_pathname + queryString;

				// Set the new url to browser url bar
				window.history.pushState({}, "Keresés", new_url);

				// If not pagination changed, set the page to 1
				if( !$form.hasClass( 'paginationChanged' ) ){
					$form.find( 'input[name="list-page"]' ).val( 1 )
				}
				$form.removeClass( 'paginationChanged' );

				// Collect form information
				let filter = $form.serialize();

				// Show loader
				$loader.show();

				// Hide ajax-content
				ajaxContainer.find( '.ajax-content' ).hide();

				// Load content
				let $ajax = $.post(
					ajax.ajaxurl,
					{
						'action': 'vp_filter_reports',
						'filter': filter
					},
					(data) => {
						if (data.success) {
							ajaxContainer.find('.ajax-content').replaceWith( data.data.html );

							if( 'map' === $form.find( 'select#reportSearchView' ).val() ){
								$(document.body).trigger('map/init');
							}
						} else {
							console.log(data);
						}

						$loader.hide();
					}
				);
			}
		});

		// Pagination
		$b.on( 'click', 'ul.pagination.ajax-pagination a', function(e){
			e.preventDefault();

			if( $(this).data( 'page' ) ){
				$form.find( 'input[name="list-page"]' ).val( $(this).data( 'page' ) );
				$form.addClass('paginationChanged').trigger( 'change' );
			}
		});
	}
});
